var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA3EmbeddedCeilingSpotOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7v62h62V7H7zm58 58H11V11h13v5h5.6a9.4 9.4 0 000 1.3A8.41 8.41 0 0038 25h.71a8.41 8.41 0 007.68-9H52v-5h13v54zM42.37 16.23a4.41 4.41 0 01-8.312 2.425A4.36 4.36 0 0133.59 17v-.33a4.587 4.587 0 010-.64h8.71c.04.05.06.12.07.2zm6.6 8.9l4.25 4.24-2.83 2.83-4.25-4.2 2.83-2.87zM36 31.75h4v6h-4v-6zm-8.85-6.62L30 28l-4.26 4.2-2.83-2.83 4.24-4.24z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A3_Embedded_ceiling_spot_on.99e03e31.svg";
export { SvgA3EmbeddedCeilingSpotOn as ReactComponent };